import { Button, Form, Input, Modal, DatePicker, Radio } from "antd";
import { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import { CONFIG } from "../../environment";
import moment from "moment";
import dayjs from "dayjs";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import CountrySelector from "../../components/countryCodeSelector";

export default function ForgotUserName({ data = {}, setData, setCurrentStep }) {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [formValues, setFormValues] = useState({});
  const [verifyDetails, setVerifyDetails] = useState({});
  const [visibleOtp, setVisibleOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(0);
  const [form] = Form.useForm();
  const [identityTypeList, setIdentityTypeList] = useState([]);
  const [successVisible, setSuccessVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [type, setType] = useState("EMAIL");

  const defaultPickerValue = selectedDate
    ? selectedDate
    : dayjs().subtract(18, "years");

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [selectedCountry, setSelectedCountry] = useState({
    isdCode: CONFIG?.DEFAULT_MOBILE_PREFIX,
    mobileLength: CONFIG?.MOBILE_NO_LENGTH,
  });
  const maxLength = parseInt(
    selectedCountry?.mobileLength || CONFIG?.MOBILE_NO_LENGTH
  );
  const onVerify = useCallback(async (values) => {
    try {
      const reqParams = {
        ...values,
        email: values?.email || "",
        customerId: "",
        mobileNo: values?.mobileNo || "",
        customerDob: dayjs(values.customerDob).format("YYYY-MM-DD"),
      };
      setFormValues(reqParams);
      const response = await AuthService.forgotUsernameVerify(reqParams);
      if (response.status === 200) {
        setVerifyDetails(response.data);
        if (response.data["otpEnable"] === false) {
          onConfirm({ ...values, otp: CONFIG.DEFAULT_OTP });
        } else {
          setData({ ...reqParams, ...response.data });
          setCurrentStep(1);
        }
      }
    } catch (error) {}
  }, []);

  const onConfirm = useCallback(
    async (values) => {
      try {
        setVisibleOtp(false);
        const response = await AuthService.forgotUsernameConfirm({
          ...values,
          ...formValues,
        });
        if (response.status === 200) {
          setMessage(response.data["message"]);
        }
      } catch (error) {
        setOtp("");
      }
    },
    [formValues]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds <= 0) {
        clearTimeout(interval);

        return false;
      }
      setSeconds(seconds - 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  });

  useEffect(() => {
    getIdentityTypes();
  }, []);

  const getIdentityTypes = useCallback(async () => {
    try {
      const response = await AuthService.getIdentityTypes({});
      if (response.status === 200) {
        setIdentityTypeList(response.data);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <div className="row justify-content-center">
        <div className="">
          <Form
            form={form}
            layout="vertical"
            onFinish={onVerify}
            initialValues={formValues}
            className=""
          >
               <Form.Item label="">
              <Radio.Group
                onChange={(e) => {
                  form.setFieldsValue({ email: "", mobileNo: "" });
                  setType(e.target.value);
                }}
                defaultValue={type}
              >
                <Radio value={"EMAIL"} tabIndex={1}>
                  {t("common.email", {
                    defaultValue: "Email Address",
                  })}
                </Radio>
                <Radio value={"MOBILE"} tabIndex={2}>
                  {t("common.mobile_number", {
                    defaultValue: "Mobile Number",
                  })}
                </Radio>
              </Radio.Group>
            </Form.Item>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              {" "}
              <Form.Item
                label={t("pages.forgotPassword.date_of_birth", {
                  defaultValue: "Date of Birth",
                })}
                name={"customerDob"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.date_of_birth_required", {
                      defaultValue: "Date Of Birth is required",
                    }),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  value={selectedDate}
                  onChange={handleDateChange}
                  defaultPickerValue={defaultPickerValue}
                  disabledDate={(current) =>
                    current.isAfter(moment().subtract(18, "years"))
                  }
                  showNow={false}
                  placeholder="DD-MM-YYYY"
                  format={{
                    format: "DD-MM-YYYY",
                    type: "mask",
                  }}
                  size="large"
                  showToday={false}
                />
              </Form.Item>
            </div>
            {type === "MOBILE" ? (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                          label={t("common.mobile_number", {
                            defaultValue: "Mobile Number",
                          })}
                          name="mobileNo"
                          rules={[
                            {
                              required: true,
                              message: t("errorMesssages.mobile_no_requir", {
                                defaultValue: "Mobile Number is required",
                              }),
                            },
                            {
                              min: maxLength,
                              max: maxLength,
                              message: t("errorMesssages.mobile_no_invalid", {
                                defaultValue: `Please enter a valid Mobile Number`,
                              }),
                            },
                          ]}
                        >
                          <NumericFormat
                            maxLength={maxLength}
                            placeholder={t("common.mobile_number", {
                              defaultValue: "Mobile Number",
                            })}
                            allowLeadingZeros={true}
                            allowNegative={false}
                            customInput={Input}
                            autoComplete="off"
                            size="large"
                            addonBefore={
                              <CountrySelector
                                selectedCountryCode={selectedCountry?.isdCode}
                                onChange={(selected) => setSelectedCountry(selected)}
                              />
                            }
                          />
                </Form.Item>
              </div>
            ) : (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {" "}
                <Form.Item
                  name="email"
                  label={t("common.email", {
                    defaultValue: "Email Address",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.email_id_require", {
                        defaultValue: "Email Address is required",
                      }),
                    },
                    {
                      type: "email",
                      message: t("errorMesssages.invalid_email", {
                        defaultValue: "Invalid Email Address",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={35}
                    placeholder={t("common.email", {
                      defaultValue: "Email Address",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}
            <div align="center">
              <Button
                className="login-button mt-2"
                block
                size="large"
                type="primary"
                htmlType="submit"
              >
                {t("buttons.submit_btn", {
                  defaultValue: "Submit",
                })}
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <Modal
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center" className="mt-4">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                navigate("/login");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
